import { MenuProps } from "antd";
import { useEffect, useLayoutEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { APP_NAME } from "../constants/constants";
import { stringToArray } from "../utils/array";

const sidebarStorageName = APP_NAME + "Sidebar";

export default function useSidebar() {
  const location = useLocation();
  const getCollapsedValue = localStorage.getItem(sidebarStorageName);
  const [collapsed, setCollapsed] = useState(getCollapsedValue === "true");
  const [openSidebar, setOpenSidebar] = useState(false);
  const [openMenuKeys, setOpenMenuKeys] = useState(["dashboard"]);

  const handleOpenMenu: MenuProps["onOpenChange"] = (keys) => {
    setOpenMenuKeys(keys);
  };

  const handleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const handleShowSidebar = () => {
    setOpenSidebar(true);
  };

  const handleCloseSidebar = () => {
    setOpenSidebar(false);
  };

  useLayoutEffect(() => {
    if (location.pathname) {
      const pathKey = stringToArray(location.pathname, "/")?.[1];

      setOpenMenuKeys([pathKey]);
    }
  }, [location.pathname]);

  useEffect(() => {
    localStorage.setItem(sidebarStorageName, JSON.stringify(collapsed));
  }, [collapsed]);

  return {
    collapsed,
    openSidebar,
    openMenuKeys,
    handleOpenMenu,
    handleCollapsed,
    handleShowSidebar,
    handleCloseSidebar,
  };
}
